export const SEARCH_PARAMS = {
  captureOpen: "captureOpen",
  backlink: "backlink",
} as const
